import { Box, Button, Paper, Typography } from '@mui/material';
import { useUpload } from 'providers/UploadProvider';
import React from 'react';

/**
 * Renders the raw upload state from UploadProvider for debugging.
 * Use under FileExplorer on the file-thingy page.
 */
export function UploadStateDebug() {
  const { uploads, isUploading, showUploadsModal } = useUpload();

  return (
    <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="overline" color="text.secondary">
          Upload state (raw)
        </Typography>
        <Button size="small" variant="outlined" onClick={showUploadsModal}>
          Show uploads modal
        </Button>
      </Box>
      <Typography variant="caption" display="block" sx={{ mb: 1 }}>
        isUploading: {String(isUploading)}
      </Typography>
      <Box
        component="pre"
        sx={{
          fontSize: '0.75rem',
          overflow: 'auto',
          maxHeight: 320,
          bgcolor: 'action.hover',
          p: 1,
          borderRadius: 1,
        }}
      >
        {JSON.stringify(uploads, null, 2)}
      </Box>
    </Paper>
  );
}
